import classes from "../classes";
import findCurrentRaceIndex from "../find-current-race-index";
import LeaderboardItem from "../containers/leaderboard-item";
import React from "react";

export default class Leaderboard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.placeholder = React.createRef();
    this.leaderboard = React.createRef();
    this.scrollableArea = React.createRef();
  }

  componentDidMount() {
    this.resize();
  }

  componentDidUpdate() {
    this.resize();
  }

  resize() {
    var { autoResize } = this.props;
    if (!autoResize) {
      return;
    }
    var top = this.placeholder.current.getBoundingClientRect().y + window.scrollY;
    this.leaderboard.current.style.top = `${top}px`;
    this.scrollableArea.current.style.maxHeight = `calc(100vh - ${top}px - 60px)`;
  }

  render() {
    var { expanded, expandedRace, onHide, races, tickets, tournament } = this.props;

    return (
      <div
        className={classes({
          "leaderboard_placeholder": true,
          "leaderboard_placeholder--is-open": expanded
        })}
        ref={this.placeholder}>
        <a className="leaderboard_action" href="#" onClick={onHide}>
          <i className="dw-times" />
        </a>

        <div className="leaderboard" ref={this.leaderboard}>
          <div className="leaderboard_heading">
            <p className="leaderboard_subheading">
              Leaderboard
            </p>

            <ul className="leaderboard_player_header">
              <li>
                Rank
              </li>

              <li>
                Player
              </li>

              <li>
                <ThirdColumnHeading expandedRace={expandedRace} races={races} tournament={tournament} />
              </li>

              <li>
                Score
              </li>
            </ul>
          </div>

          <ul className="leaderboard_list" ref={this.scrollableArea}>
            {tickets.map((ticket, i) => <LeaderboardItem isLast={i === tickets.count() - 1} key={ticket.get("id")} races={races} ticket={ticket} tournament={tournament} />)}
          </ul>
        </div>
      </div>
    );
  }
}

function ThirdColumnHeading({ expandedRace, races, tournament }) {
  if (tournament.get("status") === "final" && expandedRace === undefined) {
    return (
      <div className="leaderboard_label">
        <WinningsCurrency tournament={tournament} />

        <span className="leaderboard_label">
          Winnings
        </span>
      </div>
    );
  } else {
    var currentRaceNumber = findCurrentRaceIndex(races);
    if (expandedRace !== undefined) {
      var currentRace = races.find(race => race.get("id") === expandedRace);
      if (currentRace && currentRace.get("status") !== "open") {
        currentRaceNumber = races.findIndex(race => race.get("id") === expandedRace);
      }
    }
    if (currentRaceNumber !== undefined) {
      return (
        <span>
          R
          {(currentRaceNumber + 1).toString()}

          {" "}
          Pick
        </span>
      );
    }
  }
  return null;
}

function WinningsCurrency({ tournament }) {
  if (tournament.get("dollars_prize_pool") > 0) {
    return <i className="leaderboard_icon dw-dollars" />;
  } else if (tournament.get("token_prize_distribution") !== undefined && tournament.get("token_prize_distribution") !== null) {
    return <i className="leaderboard_icon dw-token" />;
  } else if (tournament.get("points_prize_pool") !== undefined && tournament.get("points_prize_pool") !== null) {
    return <i className="leaderboard_icon dw-points-solid" />;
  }
  return null;
}
